var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPlanAndBilling(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 101,
    height: 73,
    viewBox: "0 0 101 73",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.3 3.5V68.7C32.3 70.6 33.9 72.2 35.8 72.2H65.4C67.3 72.2 68.9 70.6 68.9 68.7V3.5C68.9 1.6 67.3 0 65.4 0H35.8C33.9 0 32.3 1.6 32.3 3.5Z",
    fill: "#82AA00"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M73.5 4V67.6H96.8C98.7 67.6 100.3 66 100.3 64.1V7.5C100.3 5.6 98.7 4 96.8 4H73.5Z",
    fill: "#989898"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M57.2 49.7002H43.9V52.4002H57.2V49.7002Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M61.9 41.6001H39.4V46.5001H61.9V41.6001Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M57.2 55H43.9V57.7H57.2V55Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M50.6 14.5C45.4 14.5 41.2 18.7 41.2 23.9C41.2 29.1 45.4 33.3 50.6 33.3C55.8 33.3 60 29 60 23.9C59.9 18.7 55.8 14.5 50.6 14.5ZM51 22.9C52.3 23.4 54.2 24.1 54.2 26.2C54.2 27.6 53.1 28.8 51.5 29.1V30.6H49.8V29.1C48.2 28.8 47.1 27.7 47.1 26.2H49.2C49.2 26.8 49.9 27.1 50.7 27.1C51.5 27.1 52.2 26.8 52.2 26.2C52.2 25.7 51.7 25.4 50.4 24.9C49.1 24.4 47.2 23.7 47.2 21.6C47.2 20.2 48.3 19 49.9 18.7V17.2H51.6V18.7C53.2 19 54.3 20.1 54.3 21.6H52.2C52.2 21 51.5 20.7 50.7 20.7C49.9 20.7 49.2 21 49.2 21.6C49.1 22.1 49.6 22.4 51 22.9Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M91.9 45.7998H81.9V48.4998H91.9V45.7998Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M95.3 37.6997H78.5V42.5997H95.3V37.6997Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M91.9 51.0996H81.9V53.7996H91.9V51.0996Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M86.9 17.7998C83.2 17.7998 80.1 20.7998 80.1 24.5998C80.1 28.3998 83.1 31.3998 86.9 31.3998C90.6 31.3998 93.7 28.3998 93.7 24.5998C93.7 20.8998 90.6 17.7998 86.9 17.7998Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M27.4 4V67.6H4.1C2.2 67.6 0.599998 66 0.599998 64.1V7.5C0.599998 5.6 2.2 4 4.1 4H27.4Z",
    fill: "#989898"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M19 45.7998H9V48.4998H19V45.7998Z",
    fill: "white"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M22.4 37.6997H5.6V42.5997H22.4V37.6997Z",
    fill: "white"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M19 51.0996H9V53.7996H19V51.0996Z",
    fill: "white"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M7.2 24.5998C7.2 28.2998 10.2 31.3998 14 31.3998C17.8 31.3998 20.8 28.3998 20.8 24.5998C20.8 20.7998 17.8 17.7998 14 17.7998C10.3 17.7998 7.2 20.8998 7.2 24.5998Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlanAndBilling);
export default __webpack_public_path__ + "static/media/plan_and_billing.84f7f316c844686038aa94a889f0ec49.svg";
export { ForwardRef as ReactComponent };